import { gql } from '@parkchirp/api-client';

export const CREATE_TAX_EXEMPT_CERTIFICATE = gql`
    mutation createTaxExemptCertificate(
    $companyName: String!
    $issueDate: String!
    $issueState: String!
    $exemptionNumber: String!
    $organizationType: String
    $expirationDate: String!
    $subscriptionId: String!
    $exemptTax1: String
    $exemptTax2: String
    $exemptTax3: String
    $exemptTax4: String
    $parkingPeriodStart: String
    $invoiceCreationStartDate: String
    $adjustmentDateType: String
    $s3Key: String
  ) {
    createTaxExemptCertificate(
      companyName: $companyName
      issueState: $issueState
      exemptionNumber: $exemptionNumber
      organizationType: $organizationType
      expirationDate: $expirationDate
      issueDate: $issueDate
      subscriptionId: $subscriptionId
      exemptTax1: $exemptTax1
      exemptTax2: $exemptTax2
      exemptTax3: $exemptTax3
      exemptTax4: $exemptTax4
      parkingPeriodStart: $parkingPeriodStart
      invoiceCreationStartDate: $invoiceCreationStartDate
      adjustmentDateType: $adjustmentDateType
      s3Key: $s3Key
    )
  }
`;

export const UPDATE_TAX_EXEMPT_CERTIFICATE = gql`
  mutation updateTaxExemptCertificate(
    $certId: String!
    $companyName: String!
    $issueDate: String!
    $issueState: String!
    $exemptionNumber: String!
    $organizationType: String
    $expirationDate: String!
    $subscriptionId: String!
    $parkingPeriodStart: String
    $parkingPeriodEnd: String
    $invoiceCreationStartDate: String
    $invoiceCreationEndDate: String
    $adjustmentDateType: String
    $s3Key: String
    $exemptTax1: String
    $exemptTax2: String
    $exemptTax3: String
    $exemptTax4: String
  ) {
    updateTaxExemptCertificate(
      certId: $certId
      companyName: $companyName
      issueDate: $issueDate
      issueState: $issueState
      exemptionNumber: $exemptionNumber
      organizationType: $organizationType
      expirationDate: $expirationDate
      subscriptionId: $subscriptionId
      parkingPeriodStart: $parkingPeriodStart
      parkingPeriodEnd: $parkingPeriodEnd
      invoiceCreationStartDate: $invoiceCreationStartDate
      invoiceCreationEndDate: $invoiceCreationEndDate
      adjustmentDateType: $adjustmentDateType
      s3Key: $s3Key
      exemptTax1: $exemptTax1
      exemptTax2: $exemptTax2
      exemptTax3: $exemptTax3
      exemptTax4: $exemptTax4
    )
  }
`;

export const DELETE_TAX_EXEMPT_CERTIFICATE_V2 = gql`
  mutation deleteTaxExemptCertificate($certId: String!, $facilityId: String!, $subscriptionId: String!) {
    deleteTaxExemptCertificate(certId: $certId, facilityId: $facilityId, subscriptionId: $subscriptionId)
  }
`;

export const UPDATE_FACILITY_AREA_V2: any = gql`
  mutation updateFacilityArea(
    $id: Int!
    $name: String!
    $code: String!
    $organizationId: Int!
  ) {
    updateFacilityArea(
      id: $id
      name: $name
      code: $code
      organizationId: $organizationId
    )
  }
`;

export const DELETE_FACILITY_AREA_V2: any = gql`
    mutation deleteFacilityArea($id: Int!, $organizationId: Int!) {
        deleteFacilityArea(id: $id, organizationId: $organizationId)
    }
`;

export const CREATE_FACILITY_AREA_V2: any = gql`
  mutation createFacilityArea(
    $name: String!
    $code: String!
    $organizationId: Int!
  ) {
    createFacilityArea(
      name: $name
      code: $code
      organizationId: $organizationId
    )
  }
`;

export const CREATE_FACILITY_BRANCH_V2: any = gql`
  mutation createFacilityBranch(
    $name: String!
    $code: String!
    $areaId: Int!
    $organizationId: Int!
  ) {
    createFacilityBranch(
      name: $name
      code: $code
      areaId: $areaId
      organizationId: $organizationId
    )
  }
`;

export const UPDATE_FACILITY_BRANCH_V2: any = gql`
  mutation updateFacilityBranch(
    $id: Int!
    $name: String!
    $code: String!
    $areaId: Int!
    $organizationId: Int!
  ) {
    updateFacilityBranch(
      id: $id
      name: $name
      code: $code
      areaId: $areaId
      organizationId: $organizationId
    )
  }
`;

export const DELETE_FACILITY_BRANCH_V2: any = gql`
  mutation deleteFacilityBranch($id: Int!, $organizationId: Int!) {
    deleteFacilityBranch(id: $id, organizationId: $organizationId)
  }
 `;

export const UPDATE_PRODUCT_CODE: any = gql`
    mutation updateProductCode(
            $id: Int!,
            $name: String!,
            $code: String!,
            $organizationId: Int!,
            $description: String
        ) {
        updateProductCode(id: $id, name: $name, code: $code, organizationId: $organizationId, description: $description)
    }
`;
export const DELETE_PRODUCT_CODE: any = gql`
  mutation deleteProductCode($id: Int!, $organizationId: Int!) {
    deleteProductCode(id: $id, organizationId: $organizationId)
  }
`;

export const CREATE_PRODUCT_CODE: any = gql`
  mutation createProductCode(
    $name: String!
    $code: String!
    $organizationId: Int!
    $description: String
  ) {
    createProductCode(
      name: $name
      code: $code
      organizationId: $organizationId
      description: $description
    )
  }
`;

export const UPDATE_FACILITY: any = gql`
  mutation updateFacility($facility: FacilityInput) {
    updateFacility(facility: $facility) {
      id
    }
  }
`;

export const CREATE_FACILITY_DISTRICT_V2: any = gql`
  mutation createFacilityDistrict(
    $name: String!
    $code: String!
    $branchId: Int!
    $organizationId: Int!
  ) {
    createFacilityDistrict(
      name: $name
      code: $code
      branchId: $branchId
      organizationId: $organizationId
    )
  }
`;

export const UPDATE_FACILITY_DISTRICT_V2: any = gql`
  mutation updateFacilityDistrict(
    $id: Int!
    $name: String!
    $code: String!
    $branchId: Int!
    $organizationId: Int!
  ) {
    updateFacilityDistrict(
      id: $id
      name: $name
      code: $code
      branchId: $branchId
      organizationId: $organizationId
    )
  }
`;

export const DELETE_FACILITY_DISTRICT_V2: any = gql`
  mutation deleteFacilityDistrict($id: Int!, $organizationId: Int!) {
    deleteFacilityDistrict(id: $id, organizationId: $organizationId)
  }
`;

export const CREATE_CONTRACT = gql`
  mutation createContract(
    $contractName: String!
    $contractType: ContractTypeEnum!
    $documentType: DocumentTypeEnum!
    $ownerLLC: String!
    $startDate: String!
    $expirationDate: String!
    $facilityId: String!
    $filePath: String
    $fileType: String
    $fileName: String
  ) {
    createContract(
      contractName: $contractName
      contractType: $contractType
      documentType: $documentType
      ownerLLC: $ownerLLC
      startDate: $startDate
      expirationDate: $expirationDate
      facilityId: $facilityId
      filePath: $filePath
      fileType: $fileType
      fileName: $fileName
    ) {
      contractId
      keyName
    }
  }
`;

export const UPDATE_CONTRACT = gql`
  mutation updateContract(
    $contractId: String!
    $facilityId: String!
    $contractName: String
    $contractType: ContractTypeEnum
    $documentType: DocumentTypeEnum
    $ownerLLC: String
    $startDate: String
    $expirationDate: String
    $filePath: String
    $fileType: String
    $fileName: String
  ) {
    updateContract(
      contractId: $contractId
      facilityId: $facilityId
      contractName: $contractName
      contractType: $contractType
      documentType: $documentType
      ownerLLC: $ownerLLC
      startDate: $startDate
      expirationDate: $expirationDate
      filePath: $filePath
      fileType: $fileType
      fileName: $fileName
    ) {
      keyName
    }
  }
`;

export const DELETE_CONTRACT = gql`
  mutation deleteContract($contractId: String!) {
    deleteContract(contractId: $contractId)
  }
`;

export const CREATE_GL_CODE = gql`
  mutation createGLCode(
    $glType: GLTypeEnum!
    $glCode: String!
    $organizationId: Int!
    $productCodeId: Int
    $contractType: GLCodeContractTypeEnum
    $rateCodeId: Int
    $facilityId: String
  ) {
    createGLCode(
      glType: $glType
      glCode: $glCode
      organizationId: $organizationId
      productCodeId: $productCodeId
      contractType: $contractType
      rateCodeId: $rateCodeId
      facilityId: $facilityId
    )
  }
`;

export const UPDATE_GL_CODE = gql`
  mutation updateGLCode(
    $glCodeId: String!
    $glType: GLTypeEnum!
    $glCode: String!
    $organizationId: Int!
    $productCodeId: Int
    $contractType: GLCodeContractTypeEnum
    $rateCodeId: Int
    $facilityId: String
  ) {
    updateGLCode(
      glCodeId: $glCodeId
      glType: $glType
      glCode: $glCode
      organizationId: $organizationId
      productCodeId: $productCodeId
      contractType: $contractType
      rateCodeId: $rateCodeId
      facilityId: $facilityId
    )
  }
`;

export const CREATE_SUBSCRIPTION = gql`
  mutation createSubscription(
    $billing_profile_id: String!
    $payor: PayorInput!
    $subscription: SubscriptionInput!
  ) {
    createSubscription(
      billing_profile_id: $billing_profile_id
      payor: $payor
      subscription: $subscription
    ) {
      id
    }
  }
`;

export const DELETE_GL_CODE = gql`
  mutation deleteGLCode(
    $glCodeId: String!
    $organizationId: Int!
    ) {
      deleteGLCode(
        glCodeId: $glCodeId
        organizationId: $organizationId
      )
  }
`;

export const CREATE_RATE_V2 = gql`
  mutation createRate(
    $name: String,
    $description: String,
    $active: Boolean,
    $display: RateDisplayEnum,
    $passType: RatePassTypeEnum,
    $accessHours: RateAccessHoursEnum,
    $location: String,
    $firstMonthProration: RateFirstMonthProrationEnum,
    $firstMonthProrationDay: Int,
    $taxExempt: Boolean,
    $billingProfileId: String,
    $requireCarInfo: RateRequireCarInfoEnum
    $monthsToSellInAdvance: Int,
    $accessDeviceMessage: String,
    $accessLevelCode: String,
    $onlineStartDate: Date,
    $onlineEndDate: Date,
    $facilityId: String!,
    $rateFeeIds: [RateFeeInput],
    $rateAccessDevices: [RateAccessDeviceInput],
    $promoCodes: [PromoCodeInput],
    $salesLimits: [SalesLimitInput],
    $parentRateId: String,
    $childRate: ChildRateArgs,
    $lateFeeDay: Int,
    $sublotId: Int,
    $integrations: [ExternalApiIntegrations],
    $isDefault: Boolean,
    $defaultRateTax1: String,
    $defaultRateTax2: String,
    $defaultRateTax3: String,
    $defaultRateTax4: String,
    $defaultRateCode: Int,
    $defaultProductCode: Int,
    $futureChildRateDiscounts: [FutureChildRateDiscountInput],
    $soldOut: Boolean
  ) {
    createRate(
      name: $name,
      description: $description,
      active: $active,
      display: $display,
      passType: $passType,
      accessHours: $accessHours,
      location: $location,
      firstMonthProration: $firstMonthProration,
      firstMonthProrationDay: $firstMonthProrationDay,
      taxExempt: $taxExempt,
      billingProfileId: $billingProfileId,
      requireCarInfo: $requireCarInfo
      monthsToSellInAdvance: $monthsToSellInAdvance,
      accessDeviceMessage: $accessDeviceMessage,
      accessLevelCode: $accessLevelCode,
      onlineStartDate: $onlineStartDate,
      onlineEndDate: $onlineEndDate,
      facilityId: $facilityId,
      rateFeeIds: $rateFeeIds,
      rateAccessDevices: $rateAccessDevices,
      promoCodes: $promoCodes,
      salesLimits: $salesLimits,
      parentRateId: $parentRateId,
      childRate: $childRate,
      lateFeeDay: $lateFeeDay,
      sublotId: $sublotId,
      integrations: $integrations,
      isDefault: $isDefault,
      defaultRateTax1: $defaultRateTax1,
      defaultRateTax2: $defaultRateTax2,
      defaultRateTax3: $defaultRateTax3,
      defaultRateTax4: $defaultRateTax4,
      defaultRateCode: $defaultRateCode,
      defaultProductCode: $defaultProductCode,
      futureChildRateDiscounts: $futureChildRateDiscounts,
      soldOut: $soldOut,
    )
  }
`;

export const UPDATE_RATE_V2 = gql`
mutation updateRate(
  $id: String,
  $name: String,
  $description: String,
  $active: Boolean,
  $display: RateDisplayEnum,
  $lostDeviceRequest: Boolean,
  $passType: RatePassTypeEnum,
  $accessHours: RateAccessHoursEnum,
  $location: String,
  $firstMonthProration: RateFirstMonthProrationEnum,
  $firstMonthProrationDay: Int,
  $taxExempt: Boolean,
  $billingProfileId: String,
  $requireCarInfo: RateRequireCarInfoEnum
  $monthsToSellInAdvance: Int,
  $accessDeviceMessage: String,
  $accessLevelCode: String,
  $onlineStartDate: Date,
  $onlineEndDate: Date,
  $facilityId: String,
  $rateFeeIds: [RateFeeInput],
  $rateAccessDevices: [RateAccessDeviceInput],
  $promoCodes: [PromoCodeInput],
  $salesLimits: [SalesLimitInput],
  $parentRateId: String,
  $childRate: ChildRateArgs,
  $lateFeeDay: Int,
  $sublotId: Int,
  $integrations: [ExternalApiIntegrations],
  $isDefault: Boolean,
  $defaultRateTax1: String,
  $defaultRateTax2: String,
  $defaultRateTax3: String,
  $defaultRateTax4: String,
  $defaultRateCode: Int,
  $defaultProductCode: Int,
  $futureChildRateDiscounts: [FutureChildRateDiscountInput],
  $soldOut: Boolean
) {
  updateRate(
    id: $id,
    name: $name,
    description: $description,
    active: $active,
    display: $display,
    passType: $passType,
    accessHours: $accessHours,
    lostDeviceRequest: $lostDeviceRequest,
    location: $location,
    firstMonthProration: $firstMonthProration,
    firstMonthProrationDay: $firstMonthProrationDay,
    taxExempt: $taxExempt,
    billingProfileId: $billingProfileId,
    requireCarInfo: $requireCarInfo
    monthsToSellInAdvance: $monthsToSellInAdvance,
    accessDeviceMessage: $accessDeviceMessage,
    accessLevelCode: $accessLevelCode,
    onlineStartDate: $onlineStartDate,
    onlineEndDate: $onlineEndDate,
    facilityId: $facilityId,
    rateFeeIds: $rateFeeIds,
    rateAccessDevices: $rateAccessDevices,
    promoCodes: $promoCodes,
    salesLimits: $salesLimits,
    parentRateId: $parentRateId,
    childRate: $childRate,
    lateFeeDay: $lateFeeDay,
    sublotId: $sublotId,
    integrations: $integrations,
    isDefault: $isDefault,
    defaultRateTax1: $defaultRateTax1,
    defaultRateTax2: $defaultRateTax2,
    defaultRateTax3: $defaultRateTax3,
    defaultRateTax4: $defaultRateTax4,
    defaultRateCode: $defaultRateCode,
    defaultProductCode: $defaultProductCode,
    futureChildRateDiscounts: $futureChildRateDiscounts,
    soldOut: $soldOut
  )
}
`;

export const DEACTIVATE_RATE = gql`
  mutation deactivateRate($rate_id: String!) {
    deactivateRate(rate_id: $rate_id)
  }
`;

export const DEACTIVATE_RATE_V2 = gql`
  mutation deactivateRate($rateId: ID!) {
    deactivateRate(rateId: $rateId)
  }
`;

export const DELETE_DEPOSIT_DOCUMENT_V2 = gql`
  mutation deleteDepositDocument($id: String!, $path: String!) {
    deleteDepositDocument(id: $id, path: $path)
  }
`;

export const PROCESS_PAYMENTS = gql`
  mutation processPayments(
    $paymentBatchId: Int!,
    ) {
    processPayments(
        paymentBatchId: $paymentBatchId
    ) {
        id
        status
      }
    }
`;

export const DEACTIVATE_FEE_V2 = gql`
  mutation deactivateFee($feeId: ID!) {
    deactivateFee(feeId: $feeId) {
      success
    }
  }
`;

export const CREATE_INVOICE = gql`
  mutation adminCreateInvoice(
    $subscriptionId: String!,
    $type: InvoiceTypeEnum,
    $invoiceDueDate: String!,
    $invoiceBillingDate: String,
    $notes: String,
    $detailNotes: String,
    $lineItems: [LineItemInput]!,
    $parkingPeriodMonth: String,
    $parkingPeriodYear: Int,
    $attachments: [Attachment!],
    $sendEmail: Boolean,
    $mailInvoice: Boolean,
    $isDraft: Boolean,
  ) {
      adminCreateInvoice(
        subscriptionId: $subscriptionId,
        type: $type,
        invoiceDueDate: $invoiceDueDate,
        invoiceBillingDate: $invoiceBillingDate,
        notes: $notes,
        detailNotes: $detailNotes,
        lineItems: $lineItems,
        parkingPeriodMonth: $parkingPeriodMonth,
        parkingPeriodYear: $parkingPeriodYear,
        attachments: $attachments,
        sendEmail: $sendEmail,
        mailInvoice: $mailInvoice,
        isDraft: $isDraft,
      )
    }
`;

export const UPDATE_DRAFT_INVOICE = gql`
  mutation updateDraftInvoice(
    $subscriptionId: String!,
    $type: InvoiceTypeEnum,
    $invoiceDueDate: String!,
    $notes: String,
    $detailNotes: String,
    $invoiceBillingDate: String,
    $lineItems: [LineItemInput]!,
    $parkingPeriodMonth: String,
    $parkingPeriodYear: Int,
    $attachments: [Attachment!],
    $sendEmail: Boolean,
    $mailInvoice: Boolean,
    $isDraft: Boolean,
    $invoiceId: String!,
    $createdByDailyReport: Boolean,
  ) {
      updateDraftInvoice(
        subscriptionId: $subscriptionId,
        type: $type,
        invoiceDueDate: $invoiceDueDate,
        invoiceBillingDate: $invoiceBillingDate,
        notes: $notes,
        detailNotes: $detailNotes,
        lineItems: $lineItems,
        parkingPeriodMonth: $parkingPeriodMonth,
        parkingPeriodYear: $parkingPeriodYear,
        attachments: $attachments,
        sendEmail: $sendEmail,
        mailInvoice: $mailInvoice,
        isDraft: $isDraft,
        invoiceId: $invoiceId,
        createdByDailyReport: $createdByDailyReport,
      )
    }
`;

export const SAVE_CREDIT_CARD = gql`
  mutation savePaymentToken(
    $token: GPIInput!,
    $cognitoSub: String!
  ) {
      savePaymentToken(
        gpi_token: $token,
        cognitoSub: $cognitoSub
      )
    }
`;

export const SAVE_BANK_ACCOUNT = gql`
  mutation savePaymentToken(
    $gpi_bank_account: GPIBankAccountInput!,
    $cognitoSub: String!,
    $paymentProviderId: Int!
  ) {
      savePaymentToken(
        gpi_bank_account: $gpi_bank_account,
        cognitoSub: $cognitoSub,
        paymentProviderId: $paymentProviderId
      )
    }
`;

export const DELETE_CREDIT_CARDS = gql`
  mutation deleteCreditCard(
    $cognitoSub: String!,
    $cardToken: [String]!,
    $subscriptionId: String!
  ) {
      deleteCreditCard(
        cognitoSub: $cognitoSub,
        cardToken: $cardToken,
        subscriptionId: $subscriptionId
      )
    }
`;

export const DELETE_BANK_ACCOUNTS = gql`
  mutation deleteBankAccounts(
    $cognitoSub: String!,
    $accountTokens: [String]!,
    $subscriptionId: String!
  ) {
      deleteBankAccounts(
        cognitoSub: $cognitoSub,
        accountTokens: $accountTokens,
        subscriptionId: $subscriptionId
      )
    }
`;

export const DELETE_SUBSCRIPTION = gql`
  mutation deleteSubscription(
    $subscriptionId: String!
  ) {
    deleteSubscription(
      subscriptionId: $subscriptionId
    )
  }
`;

export const REVERSE_PAYMENT = gql`
  mutation reversePayment(
    $paymentId: String!,
    $applicationDate: String,
    $reversalType: ReversalTypeEnum!
    ) {
      reversePayment(
        paymentId: $paymentId,
        applicationDate: $applicationDate,
        reversalType: $reversalType
      ) {
        invoice {
          id
        }
        overpaymentCredit {
          readableId
        }
        creditReversed
      }
    }
`;

export const CREATE_USER = gql`
  mutation createUser(
    $email: String!,
    $firstName: String!,
    $lastName: String!,
    $roleId: Int!,
    $facilities: [String]!,
    $facilityAreas: [Int]!,
    $facilityBranches: [Int]!,
    $facilityDistricts: [Int]!,
  ) {
    createUser(
      email: $email,
      firstName: $firstName,
      lastName: $lastName,
      roleId: $roleId,
      facilities: $facilities,
      facilityAreas: $facilityAreas,
      facilityBranches: $facilityBranches,
      facilityDistricts: $facilityDistricts,
    ) {
      userId
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser(
    $id: String!,
    $firstName: String!,
    $lastName: String!,
    $roleId: Int!
    $facilities: [String]!,
    $facilityAreas: [Int]!,
    $facilityBranches: [Int]!,
    $facilityDistricts: [Int]!,
  ) {
    updateUser(
        id: $id,
        firstName: $firstName,
        lastName: $lastName,
        roleId: $roleId
        facilities: $facilities,
        facilityAreas: $facilityAreas,
        facilityBranches: $facilityBranches,
        facilityDistricts: $facilityDistricts,
    )
  }
`;

export const REMOVE_USER_FROM_ORGANIZATION = gql`
  mutation removeUserFromOrganization($userId: String!) {
    removeUserFromOrganization(userId: $userId)
  }
`;

export const UPDATE_PAYMENT_GROUP_NOTES = gql`
  mutation updatePaymentGroupNotes(
      $id: Int!
      $notes: String!
  ) {
    updatePaymentGroupNotes(
         id: $id
         notes: $notes
      )
    }
`;

export const DELETE_USER = gql`
  mutation deleteUser(
    $id: String!,
  ) {
    deleteUser(
        id: $id,
    )
  }
`;

export const DELETE_DRAFT_INVOICE = gql`
    mutation deleteDraftInvoice(
        $id: String!
    ) {
        deleteDraftInvoice(
            id: $id
        )
    }
`;
